module.exports = __webpack_public_path__ + "static/img/show_certiicate.22d64133.svg";